import JSONUtils from '@mm/state/helpers/json-utils';
import {
  LivechatMessageModel,
  MessageCampaignAttributes,
  MessageStructure,
} from '@mm/state/model/LivechatMessageModel';
import ObjectUtils from '../../../../../common/helpers/utils/object-utils';

export type ParsedMessage = {
  text: string | undefined;
  buttonsTexts?: string[];
};

export const parseMessageStructureAndCampaign = (
  message: LivechatMessageModel,
) => {
  const parsedStructure =
    JSONUtils.safeParse(message.structure as unknown as string) || {};
  const parsedCampaign =
    JSONUtils.safeParse(message.campaign as unknown as string) || {};
  let jsParsedStructure = {};
  let jsCampaignStructure = {};

  if (parsedStructure) {
    jsParsedStructure = ObjectUtils.deepCamelizeKeys(parsedStructure);
  }

  if (parsedCampaign) {
    jsCampaignStructure = ObjectUtils.deepCamelizeKeys(parsedCampaign);
  }

  return {
    ...message,
    campaign: jsCampaignStructure as MessageCampaignAttributes,
    structure: jsParsedStructure as MessageStructure,
  };
};
